import { motion } from 'framer-motion';

// Concentric red circles with a slow "breathing" pulse: 9s ease-in-out loop,
// scale 100→108→100%, opacity 45→60→45%, peaking together at the 50% mark.
// Positioned lower-left, partially bleeding off the edge, behind the headline.
export default function PulsatingCircles() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <motion.div
        className="absolute"
        style={{
          width: 'min(88vw, 860px)',
          height: 'min(88vw, 860px)',
          left: '-6%',
          top: '4%'
        }}
        animate={{ scale: [1, 1.08, 1], opacity: [0.45, 0.6, 0.45] }}
        transition={{ duration: 9, ease: 'easeInOut', repeat: Infinity, times: [0, 0.5, 1] }}
      >
        <svg viewBox="0 0 820 820" className="w-full h-full" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="410" cy="410" r="405" fill="#ef3a48" fillOpacity="0.18" />
          <circle cx="410" cy="410" r="330" fill="#e02233" fillOpacity="0.45" />
          <circle cx="410" cy="410" r="250" fill="#b3121f" fillOpacity="0.85" />
        </svg>
      </motion.div>
    </div>
  );
}
